import angular from 'angular'
import './campaigns.service'
import './edit/edit.controller'
import './promos/promos.controller'
import './promos/promos.service'
import './promos/edit/edit.controller'
import './promos/codes/codes.controller'
import './promos/codes/codes.service'
import './promos/codes/edit/edit.controller'

angular
  .module('admin.campaigns', [
    'admin.campaigns.edit',
    'admin.campaigns.service',
    'admin.campaigns.promo',
  ])
  .controller('CampaignsCtrl', CampaignsCtrl)

/** @ngInject */
function CampaignsCtrl($scope, $state, $timeout, $stateParams, CampaignsService) {
  var vm = this
  vm.itemsGeneral = []
  vm.itemsAffiliate = []
  vm.model = {}

  function reloadPaginationGeneral() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationAffiliate() {
    vm.totalUsers2 = 0
    vm.perPage2 = 25
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  vm.sortType = 'id-desc'
  vm.sortReverse = true
  vm.sortType2 = 'id-desc'
  vm.sortReverse2 = true

  var tab = localStorage.getItem('tabcampaign')
  if (tab !== null) {
    if (tab === 'general') {
      $('#affiliate').removeClass('active')
      $('#general').addClass('active')
      $('#generaltab').addClass('active')
    } else {
      $('#general').removeClass('active')
      $('#affiliate').addClass('active')
      $('#affiliatetab').addClass('active')
    }
  } else {
    $('#general').addClass('active')
    $('#generaltab').addClass('active')
  }

  reloadPaginationGeneral()
  reloadPaginationAffiliate()
  loadGeneral(1)
  loadAffiliate(1)

  var oldSortType
  function loadGeneral(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    CampaignsService.listGeneral(vm.oldPage, 25, vm.sortType).then(function(result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.sortType = oldSortType
      vm.itemsGeneral = items
    })
  }

  var oldSortType2
  function loadAffiliate(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    CampaignsService.listAffiliate(vm.oldPage2, 25, vm.sortType2).then(function(result) {
      var items = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.sortType2 = oldSortType2
      vm.itemsAffiliate = items
    })
  }

  vm.pageChangedGeneral = function(newPage) {
    vm.sortType = oldSortType
    loadGeneral(newPage)
  }

  vm.pageChangedAffiliate = function(newPage) {
    vm.sortType2 = oldSortType2
    loadAffiliate(newPage)
  }

  vm.tabGeneral = function() {
    $('#affiliate').removeClass('active')
    $('#general').addClass('active')
    localStorage.setItem('tabcampaign', 'general')
  }

  vm.tabAffiliate = function() {
    $('#general').removeClass('active')
    $('#affiliate').addClass('active')
    localStorage.setItem('tabcampaign', 'affiliate')
  }

  vm.add = function() {
    $state.go('admin.promo_campaigns.edit', { id: 0 })
  }

  vm.edit = function(item) {
    $state.go('admin.promo_campaigns.edit', { id: item.id })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          CampaignsService.remove(item.id).then(
            function() {
              $state.reload()
            },
            function(err) {
              var msgError = 'You cannot delete a campaign with promos active'
              if (
                err.error.message.indexOf('fk_promo_campaign_affiliates_promo_campaign_id') !== -1
              ) {
                msgError = 'You cannot delete a campaign because has affiliates associated'
              }
              $timeout(function() {
                swal(msgError, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    loadGeneral(vm.pagination.current)
  }

  vm.sort2 = function(type) {
    vm.sortReverse2 = !vm.sortReverse2
    if (vm.sortReverse2) {
      vm.sortType2 = type + '-asc'
    } else {
      vm.sortType2 = type + '-desc'
    }
    loadAffiliate(vm.pagination2.current)
  }
}
